var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefresh = function SvgRefresh(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68789 6.85708L5.83081 5L4.83081 11L10.8308 10L9.12532 8.29451C9.9052 7.79174 10.834 7.5 11.8308 7.5V5.5C10.2805 5.5 8.84789 6.004 7.68789 6.85708Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35773 14.7366C8.17862 16.3751 9.87337 17.5 11.8308 17.5V19.5C9.09038 19.5 6.71773 17.9252 5.56848 15.6312L7.35773 14.7366Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9737 18.1429L17.8308 20L18.8308 14L12.8308 15L14.5363 16.7055C13.7564 17.2083 12.8277 17.5 11.8308 17.5V19.5C13.3812 19.5 14.8137 18.996 15.9737 18.1429Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3039 10.2634C15.483 8.62486 13.7883 7.5 11.8308 7.5V5.5C14.5713 5.5 16.9439 7.0748 18.0931 9.36882L16.3039 10.2634Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };